<script>
import { mapGetters } from 'vuex';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
  },
  emits: ['replace', 'attach'],
  computed: {
    ...mapGetters({
      cannedMessages: 'getCannedResponses',
    }),
    items() {
      const sorted = [...this.cannedMessages].sort((a, b) => {
        const ca = a.category || '';
        const cb = b.category || '';
        if (!ca && cb) return 1;
        if (ca && !cb) return -1;
        if (ca !== cb) return ca.localeCompare(cb);
        return (a.short_code || '').localeCompare(b.short_code || '');
      });
      let lastFolder = null;
      return sorted.map(cannedMessage => {
        const folder =
          cannedMessage.category || this.$t('CANNED_MGMT.LIST.UNCATEGORIZED');
        const folderHeader = folder !== lastFolder ? folder : null;
        lastFolder = folder;
        return {
          id: cannedMessage.id,
          label: cannedMessage.short_code,
          key: cannedMessage.short_code,
          description: cannedMessage.content,
          attachments: cannedMessage.attachments || [],
          folderHeader,
        };
      });
    },
  },
  watch: {
    searchKey() {
      this.fetchCannedResponses();
    },
  },
  mounted() {
    this.fetchCannedResponses();
  },
  methods: {
    fetchCannedResponses() {
      this.$store.dispatch('getCannedResponse', { searchKey: this.searchKey });
    },
    handleMentionClick(item = {}) {
      if (item.id) {
        this.$store.dispatch('markCannedResponseUsed', item.id);
      }
      this.$emit('replace', item.description);
      if (item.attachments && item.attachments.length) {
        this.$emit('attach', item.attachments);
      }
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    @mention-select="handleMentionClick"
  />
</template>
